import { IdOutskirtBuildings } from "./IdOutskirtBuildings";
export var mapOutskirtCalloutOffset = new Map([
    [IdOutskirtBuildings.Watertower, new PIXI.Point(15, -200)],
    [IdOutskirtBuildings.TournamentTent, new PIXI.Point(0, -180)],
    [IdOutskirtBuildings.Cafe, new PIXI.Point(0, -110)],
    [IdOutskirtBuildings.Doghouse, new PIXI.Point(0, -115)],
    [IdOutskirtBuildings.ExternalBarn, new PIXI.Point(35, -225)],
    [IdOutskirtBuildings.Harbor, new PIXI.Point(0, 0)],
    [IdOutskirtBuildings.Library, new PIXI.Point(100, -400)],
    [IdOutskirtBuildings.Market, new PIXI.Point(200, -100)],
    [IdOutskirtBuildings.Nursery, new PIXI.Point(0, -90)],
    [IdOutskirtBuildings.Pier, new PIXI.Point(0, 0)],
    [IdOutskirtBuildings.ThemedEvent, new PIXI.Point(0, -180)],
]);



//////////////////
// WEBPACK FOOTER
// ./src/constants/mapOutskirtCalloutOffset.ts
// module id = 858
// module chunks = 3